import { useEffect } from 'react';
import { useForm } from 'react-final-form';

import { createTypedUseFormValue } from 'hooks/useTypedFormField';
import { parseDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { ICreatePreventionForm } from 'PreventionPackage/MainModule/interfaces/ICreatePreventionForm';

const useFieldValue = createTypedUseFormValue<ICreatePreventionForm>();

export const useCreatePreventionModalFieldsReset = () => {
  const { change } = useForm<ICreatePreventionForm>();

  const knoOrganizationPm = useFieldValue('knoOrganizationPm');
  const federalLaw = useFieldValue('federalLaw');
  const supervisionTypePm = useFieldValue('supervisionTypePm');
  const profKind = useFieldValue('profKind');
  const startDate = useFieldValue('startDate');
  const stopDate = useFieldValue('stopDate');

  useEffect(() => {
    change('supervisionTypePm', undefined);
    change('profKind', undefined);
    change('reason', undefined);
  }, [knoOrganizationPm, federalLaw]);

  useEffect(() => {
    change('profKind', undefined);
    change('reason', undefined);
  }, [supervisionTypePm]);

  useEffect(() => {
    change('reason', undefined);
  }, [profKind, startDate, stopDate]);

  useEffect(() => {
    if (!startDate || !stopDate) return;

    const eventStartDate = parseDate({ date: startDate, parseFormat: DATE_FORMAT_LONG_FNS });
    const eventStopDate = parseDate({ date: stopDate, parseFormat: DATE_FORMAT_LONG_FNS });

    if (eventStartDate && eventStopDate && eventStartDate > eventStopDate) {
      change('stopDate', undefined);
    }
  }, [startDate, stopDate]);

  return null;
};
